import { render, staticRenderFns } from "./GiftPaymentMethod.vue?vue&type=template&id=706a9312&scoped=true&"
import script from "./GiftPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./GiftPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./GiftPaymentMethod.vue?vue&type=style&index=0&id=706a9312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a9312",
  null
  
)

export default component.exports